import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<p class="assets-viewer__status assets-viewer__status--error">Failed to load the bake manifest: `),
  _tmpl$2 = /*#__PURE__*/_$template(`<p class=assets-viewer__status>Loading manifest…`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class="assets-viewer__main assets-viewer__main--unbaked">`),
  _tmpl$4 = /*#__PURE__*/_$template(`<div class=assets-viewer__main><section class=assets-viewer__list-pane><div class=assets-viewer__list-header><input type=search class=assets-viewer__search placeholder="Search by name or source path…"><span class=assets-viewer__list-count></span></div><ul class=assets-viewer__entry-list tabindex=0>`),
  _tmpl$5 = /*#__PURE__*/_$template(`<div class=assets-viewer><nav class=assets-viewer__sidebar aria-label="Asset categories"><h2>Categories</h2><ul><li><button type=button class="assets-viewer__category assets-viewer__category--unbaked"><span>Unbaked</span><span class=assets-viewer__count>`),
  _tmpl$6 = /*#__PURE__*/_$template(`<li><button type=button class=assets-viewer__category><span></span><span class=assets-viewer__count>`),
  _tmpl$7 = /*#__PURE__*/_$template(`<li class=assets-viewer__empty>No assets match.`),
  _tmpl$8 = /*#__PURE__*/_$template(`<li><button type=button class=assets-viewer__entry>`);
import { ASSET_CATEGORIES } from "@red-opus/baker/schema";
import { createMemo, createResource, createSignal, For, Show } from "solid-js";
import { DetailPane } from "../assets/DetailPane.tsx";
import { groupByCategory, searchEntries } from "../assets/filter.ts";
import { nextIndex } from "../keyboard-nav.ts";
import { loadManifest } from "../assets/manifest.ts";
import { UnbakedList } from "../assets/viewers/UnbakedList.tsx";
import { formatCategoryLabel } from "../format-category-label.ts";
/**
 * `/assets` — the baked-asset review suite (AD-001). Categories, counts,
 * and every listed asset come from `data/baked/manifest.json` (built by
 * `tools/bake`) — nothing here is hardcoded, so the sidebar can never
 * drift out of sync with what actually got baked.
 */
export function AssetsViewer() {
  const [manifest] = createResource(loadManifest);
  const [selection, setSelection] = createSignal("palettes");
  const [query, setQuery] = createSignal("");
  const [selectedIndex, setSelectedIndex] = createSignal(0);
  const categoryCounts = createMemo(() => groupByCategory(manifest()?.entries ?? [], ASSET_CATEGORIES));
  const unbakedCount = createMemo(() => manifest()?.unbaked.length ?? 0);
  const visibleEntries = createMemo(() => {
    const current = selection();
    if (current === "unbaked") return [];
    const inCategory = (manifest()?.entries ?? []).filter(entry => entry.category === current);
    return searchEntries(inCategory, query());
  });
  const selectedEntry = createMemo(() => visibleEntries()[selectedIndex()]);
  function selectSidebar(next) {
    setSelection(next);
    setQuery("");
    setSelectedIndex(0);
  }
  function onListKeyDown(event) {
    if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
    event.preventDefault();
    const direction = event.key === "ArrowDown" ? "down" : "up";
    setSelectedIndex(current => nextIndex(current, direction, visibleEntries().length));
  }
  return (() => {
    var _el$ = _tmpl$5(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$4 = _el$3.nextSibling,
      _el$5 = _el$4.firstChild,
      _el$6 = _el$5.firstChild,
      _el$7 = _el$6.firstChild,
      _el$8 = _el$7.nextSibling;
    _$insert(_el$4, _$createComponent(For, {
      get each() {
        return categoryCounts();
      },
      children: entry => (() => {
        var _el$17 = _tmpl$6(),
          _el$18 = _el$17.firstChild,
          _el$19 = _el$18.firstChild,
          _el$20 = _el$19.nextSibling;
        _el$18.$$click = () => selectSidebar(entry.category);
        _$insert(_el$19, () => formatCategoryLabel(entry.category));
        _$insert(_el$20, () => entry.count);
        _$effect(() => _el$18.classList.toggle("assets-viewer__category--active", !!(selection() === entry.category)));
        return _el$17;
      })()
    }), _el$5);
    _el$6.$$click = () => selectSidebar("unbaked");
    _$insert(_el$8, unbakedCount);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return manifest.error;
      },
      get children() {
        var _el$9 = _tmpl$(),
          _el$0 = _el$9.firstChild;
        _$insert(_el$9, () => String(manifest.error), null);
        return _el$9;
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return manifest.loading;
      },
      get children() {
        return _tmpl$2();
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return _$memo(() => !!manifest())() && selection() === "unbaked";
      },
      get children() {
        var _el$10 = _tmpl$3();
        _$insert(_el$10, _$createComponent(UnbakedList, {
          get entries() {
            return manifest().unbaked;
          }
        }));
        return _el$10;
      }
    }), null);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return _$memo(() => !!manifest())() && selection() !== "unbaked";
      },
      get children() {
        var _el$11 = _tmpl$4(),
          _el$12 = _el$11.firstChild,
          _el$13 = _el$12.firstChild,
          _el$14 = _el$13.firstChild,
          _el$15 = _el$14.nextSibling,
          _el$16 = _el$13.nextSibling;
        _el$12.$$keydown = onListKeyDown;
        _el$14.$$input = event => {
          setQuery(event.currentTarget.value);
          setSelectedIndex(0);
        };
        _$insert(_el$15, () => visibleEntries().length);
        _$insert(_el$16, _$createComponent(For, {
          get each() {
            return visibleEntries();
          },
          get fallback() {
            return _tmpl$7();
          },
          children: (entry, index) => (() => {
            var _el$22 = _tmpl$8(),
              _el$23 = _el$22.firstChild;
            _el$23.$$click = () => setSelectedIndex(index());
            _$insert(_el$23, () => entry.id);
            _$effect(() => _el$23.classList.toggle("assets-viewer__entry--active", !!(index() === selectedIndex())));
            return _el$22;
          })()
        }));
        _$insert(_el$11, _$createComponent(DetailPane, {
          get entry() {
            return selectedEntry();
          }
        }), null);
        _$effect(() => _el$14.value = query());
        return _el$11;
      }
    }), null);
    _$effect(() => _el$6.classList.toggle("assets-viewer__category--active", !!(selection() === "unbaked")));
    return _el$;
  })();
}
_$delegateEvents(["click", "keydown", "input"]);